<template>
  <div>
    <el-dialog
      append-to-body
      class="uspesno-obvestilo"
      :visible.sync="dialogVabiloUspesnoPoslano"
      center>
      <div class="ikona-uspesno">
        <img src="/static/img/MojProfil/Icon-feather-check.png">
      </div>
      <div>
        <p class="navadno-besedilo krepko-center text-block-center">
          Vabilo je bilo uspešno poslano.
        </p>
      </div>
      <div style="padding-top: 10px">
        <p class="navadno-besedilo text-block-center okno-center">
          Uporabnik bo prejel obvestilo na vpisan e-naslov.
        <span class="text-block-center">
          Če bo vabilo sprejel, bo lahko urejal nastavitve ali imel pregled nad storitvami,
          za katere ste dodelili pravice.
        </span>
        </p>
      </div>
      <el-button class="gumb-brez-obrob krepko crna" @click="dialogVabiloUspesnoPoslano = false">
        Zapri
      </el-button>
    </el-dialog>
    <div style="padding-top: 30px">
      <div>
        <el-form label-width="200px" class="forma-uporabnik nova-vrstica-forma" :label-position="formaOrientacija">
          <div>
            <div style="padding-top: 20px">
              <p class="navadno-besedilo">
                Naročniki T-2 storitev lahko na portalu MOJ T-2 omogočite soupravljanje naročnine z drugimi člani
                gospodinjstva ali sodelavci v podjetju. Dodeljene pravice omogočajo dostop do izbranih
                funkcionalnosti, kot so pregled porabe in nastavitev za posamezno telefonsko številko, urejanje
                elektronskih predalov, upravljanje ePoslovanja in druge možnosti.
              </p>
            </div>
            <el-alert
              v-if="zacasnaNarocnina"
              title="Onemogočeno dodajanje pravic"
              type="error"
              description="Povezano imate začasno naročnino stranke. Za to naročnino preko moj.t-2.net ne morete urejati pravic. Za urejanje pravic prosim uporabite vmesnik na Stranki 360."
              show-icon>
            </el-alert>
            <div style="padding-top: 20px" class="pb-3">
              <span class="navadno-besedilo">
                <b>
                  1. E-naslov uporabnika
                </b>
              </span>
            </div>
            <div>
              <p class="navadno-besedilo">
                Vpišite e-naslov uporabnika, ki mu želite dodeliti pravico. Pogoj za sprejem in upravljanje pravic
                je, da ima uporabnik ustvarjen svoj
                <a :href="povezavaRegistracija" class="primarna-barva">
                  T-2 ID</a>.
              </p>
              <div style="padding-top: 20px">
                <el-form-item label="E-naslov uporabnika">
                  <el-input placeholder="Vpišite elektronski naslov"
                            class="velikost-input"
                            :class="!emailUporabnikaEnakT2ID || 'error'"
                            v-model="emailUporabnika"
                            type="email">
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div>
            <div style="padding-top: 30px">
              <span class="navadno-besedilo">
                <b>
                  2. Izberite naročnino in priključek
                </b>
              </span>
            </div>
          </div>
          <div style="padding-top: 20px">
            <el-form-item label="Naročnina">
              <IzbirnikStranke
                :custom-style="prikazTabele === '1' ? 'width:330px' : ''"
                v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
            </el-form-item>
            <el-form-item label="Priključek">
              <IzbirnikPrikljuckaSelect
                :custom-style="prikazTabele === '1' ? 'width:330px' : ''"
                @novIzbranPrikljucek="IzbranPrikljucekEvent($event)"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
              />
            </el-form-item>
          </div>
          <div>
            <div style="padding-top: 30px">
              <span class="navadno-besedilo">
                <b>
                  3. Izberite pravico in pošljite vabilo izbranemu prejemniku
                </b>
              </span>
            </div>
          </div>
          <div v-loading="pridobivanjeNaboraPravic">
            <div style="padding-top: 30px" v-if="naborPravic.length > 0">
              <el-table
                class="tabela-pravice"
                v-loading="posiljanjeVProteku"
                element-loading-text="Pošiljanje ..."
                :data="naborPravic">
                <el-table-column
                  min-width="120"
                  label="Tip"
                  class-name="tip-celica">
                  <template slot-scope="scope">
                    <span>{{ scope.row.title }}</span>
                    <span v-if="prikazTabele === '0'" class="info-ob-nazivu">
                      <el-tooltip class="item primarna-barva"
                                  :content="scope.row.description"
                                  placement="top">
                        <el-icon class="el-icon-info"></el-icon>
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="description"
                  label="Opis"
                  min-width="160"
                  v-if="prikazTabele === '1'">
                </el-table-column>
                <el-table-column
                  label="Izberi"
                  min-width="180"
                  class-name="izbira-celica">
                  <template slot-scope="scope">
                    <div class="e-naslov">
                      <el-select v-model="izbiraParametra[scope.row.permissionId]" clearable
                                 multiple
                                 class="velikost-selecta oznake-scopov"
                                 @clear="pocistiIzbiro(scope.row.permissionId)"
                                 v-bind:placeholder="scope.row.placeholder">
                        <el-option v-for="(data, key) in scope.row.results"
                                   :value="data.selectorValue"
                                   :label="data.selectorLabel"
                                   :key="key">
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      v-if="prikazTabele === '0'"
                      class="mt-2"
                      style="display: flex; flex-direction: column; align-items: flex-start">
                      <el-button
                        class="primary gumb-potrdi"
                        :disabled="emailUporabnikaEnakT2ID || steviloIzbranihScopov(scope.row.permissionId) === 0 || zacasnaNarocnina"
                        @click="DodeljevanjePravic(scope.row.permissionId)">
                          <span>
                            {{ gumbBesedilo(scope.row.permissionId, 'POŠLJI') }}
                          </span>
                      </el-button>
                      <a class="stil-gumb-preklici" @click="pocistiIzbiro(scope.row.permissionId)"
                         v-if="steviloIzbranihScopov(scope.row.permissionId) > 0"
                         type="primary">
                        PREKLIČI
                      </a>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Akcija" min-width="210" class-name="akcija-celica" v-if="prikazTabele === '1'">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        class="primary gumb-potrdi"
                        :disabled="emailUporabnikaEnakT2ID || steviloIzbranihScopov(scope.row.permissionId) === 0 || zacasnaNarocnina"
                        @click="DodeljevanjePravic(scope.row.permissionId)">
                        <span>
                          {{ gumbBesedilo(scope.row.permissionId, 'POŠLJI POVABILO') }}
                        </span>
                      </el-button>
                      <a class="stil-gumb-preklici" @click="pocistiIzbiro(scope.row.permissionId)"
                         v-if="steviloIzbranihScopov(scope.row.permissionId) > 0"
                         type="primary">
                        PREKLIČI
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <div style="padding-top: 30px">
                <p>
                  Žal nimate nabora pravic.
                </p>
              </div>
            </div>
          </div>
        </el-form>
        <div style="margin-top: 100px;">
          <a :href=stranUrl class="primarna-barva" target="_blank">
            <div>
              <div id="bottom">
                <div class="postavitev-besedila-pomoc">
                  <p class="open-sans-13pt no-bold">
              <span class="desni-pomik-texta-pomoc">
                <b>
                  Potrebujete pomoč?
                </b>
              </span>
                    <br />
                    Imamo odgovore na pogosta vprašanja,
                    <br />
                    lahko nas tudi pokličete na 064 064 064.
                  </p>
                </div>
                <div class="desna-postavitev-ikone-pomoc">
                  <i class="fa fa-question-circle"></i>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Checkbox, Button, Option, Select, Radio, Form, FormItem, Input, Table, TableColumn, DatePicker, Dialog, Tooltip
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import Vue from 'vue'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikStranke from '../../GlobalneKomponente/IzbirnikStranke.vue'
import { DeljenjePravicPretvornik } from '../../../../../assets/js/globalne_funkcije/Pravice/DeljenjePravicPretvornik'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import {UrejenSeznamPrikljuckov} from '../../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {Obvestilo} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/Notification'
import PrivzetaVrednostLogic from '../../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
import {PrivzetaVrednostTipEnum} from '../../../../../assets/js/Enum/PrivzetaVrednostTipEnum'
import {DisabledPermissionsForMobileEnum} from '../../../../../assets/js/Enum/DisabledPermissionsForMobileEnum'
import Cookie from 'js-cookie'
export default {
  name: 'Uporabniki',
  mixins: [PrikazVsebine, GetPodatkiIzbirnika, PridobiStranko],
  data () {
    return {
      formaOrientacija: 'left',
      mejnaSirinaTabela: 1440,
      emailUporabnika: '',
      narocninaUporabnika: '',
      prikljucekUporabnika: '',
      naborPravic: [],
      posiljanjeVProteku: false,
      izbiraParametra: '',
      pridobivanjeNaboraPravic: false,
      dialogVabiloUspesnoPoslano: false,
      clientAgent: null,
      seznamVsehPrikljuckov: [],
      izbranPrikljucek: '',
      izbranaStrankaSap: '',
      izbranaStranka: '',
      pravice: [],
      seznam: [],
      validacija: null,
      prikazTabele: '1',
      mejnaSirina: 360,
      seznamPrikljuckovOtt: [],
      seznamPrikljuckovGrupirano: [],
      povezavaPraviceUporabniki: '',
      T2ID: '',
      emailUporabnikaEnakT2ID: false,
      enakEmailOpozorilo: 'Vnesli ste e-poštni naslov, ki že upravlja naročnino. Preverite in poskusite znova.',
      povezavaRegistracija: '',
      stranUrl: ''
    }
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    emailUporabnika: function (val) {
      this.emailUporabnikaEnakT2ID = val.toLowerCase() === this.T2ID
      if (this.emailUporabnikaEnakT2ID) {
        let paramObvestilo = {message: this.enakEmailOpozorilo}
        Obvestilo.methods.ShowWarningMessage(paramObvestilo)
      }
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    UrejenSeznamPrikljuckov,
    IzbirnikStranke,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tooltip.name]: Tooltip
  },
  computed: {
    zacasnaNarocnina () {
      return this.izbranaStrankaSap === Cookie.get('zacasnaNarocnina')
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetUserData()
    this.povezavaPraviceUporabniki = povezave.BASE_URL_PRAVICE_UPORABNIKI
    this.povezavaRegistracija = povezave.BASE_URL_REGISTRACIJA
    this.stranUrl = povezave.BASE_URL_PRAVICE_UPORABNIKI
    this.validacija = new Validacija()
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    PrenosniPodatkiStranka (osebnikPodatki) {
      this.T2ID = osebnikPodatki.email
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
        this.izbranaStranka = podatkiStranke.id_stranka
        this.GetPrikljuckiDovoljenja(podatkiStranke.id_stranka)
      }
    },
    IzbranPrikljucekEvent (idPrikljucek) {
      this.izbranPrikljucek = idPrikljucek
      this.NaborPravicZaDodeljevanje()
    },
    NaborPravicZaDodeljevanje () {
      this.pridobivanjeNaboraPravic = true
      this.naborPravic = []
      this.izbiraParametra = {}
      let param = ['appendResults=' + true]
      param.push('filter[id_prikljucek]=' + this.izbranPrikljucek)
      param.push('filter[id_stranka_sap]=' + this.izbranaStrankaSap)
      param.push('filter[id_stranka]=' + this.izbranaStranka)
      this.clientAgent.postWsRequest(this,
        'permissions/getAllShareablePermissions?',
        param,
        null,
        'GetNaborPravicZaDodeljevanje',
        'ErrNaborPravicZaDodeljevanje')
    },
    GetNaborPravicZaDodeljevanje (podatki, skipSetter = false) {
      if (!skipSetter) {
        this.naborPravic = DeljenjePravicPretvornik.methods.GetPretvorjenSeznamPravic(podatki.data)
      }
      let prikljucekDelPaketa = this.seznamVsehPrikljuckov.find(
        x => x.id_prikljucek === this.izbranPrikljucek && x.tip_prikljucka === 'UMTS' && x.je_nosilni === '0'
      )
      for (let pravica of this.naborPravic) {
        this.pocistiIzbiro(pravica.permissionId)
      }
      if (prikljucekDelPaketa) {
        this.naborPravic = this.naborPravic.filter(x => !DisabledPermissionsForMobileEnum.includes(x.permissionId))
      }
      this.naborPravic.sort((a, b) => {
        const moveToBottom = ['EPOSLOVANJE', 'NASTAVITVE_TELEFONIJA']
        const aIsBottom = moveToBottom.includes(a.permissionId)
        const bIsBottom = moveToBottom.includes(b.permissionId)

        if (aIsBottom && !bIsBottom) return 1
        if (!aIsBottom && bIsBottom) return -1
        return 0
      })
      this.pridobivanjeNaboraPravic = false
    },
    ErrNaborPravicZaDodeljevanje (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeNaboraPravic = false
    },
    PreveriParametre (pravica, izbiraParametra) {
      let errorMsg = {}
      if (this.emailUporabnika === '') {
        errorMsg.message = 'Vpišite elektronski naslov prejemnika'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      if (izbiraParametra === null) {
        errorMsg.message = 'Izberite številko/enaslov, ki ga želite deliti'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      if (pravica === null) {
        errorMsg.message = 'Izberite pravico, ki jo želite deliti'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      return true
    },
    pocistiIzbiro (permissionId) {
      // Večizbira scopov je omogočena za vse pravice, zato vedno počistimo v prazen array.
      Vue.set(this.izbiraParametra, permissionId, [])
    },
    izbraniScopi (permissionId) {
      let izbrani = this.izbiraParametra[permissionId]
      if (Array.isArray(izbrani)) {
        return izbrani.filter(x => x !== null && x !== undefined && x !== '')
      }
      return (izbrani !== null && izbrani !== undefined && izbrani !== '') ? [izbrani] : []
    },
    steviloIzbranihScopov (permissionId) {
      return this.izbraniScopi(permissionId).length
    },
    gumbBesedilo (permissionId, privzetoBesedilo) {
      return this.steviloIzbranihScopov(permissionId) > 1 ? 'POŠLJI POVABILA' : privzetoBesedilo
    },
    async DodeljevanjePravic (selectedPermission = null) {
      if (selectedPermission === null) {
        return
      }
      let scopi = this.izbraniScopi(selectedPermission)
      if (scopi.length === 0) {
        this.ShowWarningMessage({message: 'Izberite vsaj eno pravico iz nabora.'})
        return
      }
      if (this.emailUporabnika === '') {
        this.ShowWarningMessage({message: 'Vpišite elektronski naslov prejemnika'})
        return
      }
      // Vse izbrane scope pošljemo v enem klicu; BE preskoči nedeljive (npr. že dodeljene)
      // in vrne število uspešnih (grantedCount) ter seznam preskočenih z razlogom (skipped).
      this.posiljanjeVProteku = true
      try {
        let odgovor = await this.clientAgent.makeRequest(
          'permissions/grantPermission',
          {
            email: this.emailUporabnika,
            permissions: JSON.stringify([{id: selectedPermission, scope: scopi.map(String)}])
          }
        )
        this.PrikaziRezultatDodelitve(odgovor)
      } catch (e) {
        this.ShowWarningMessage({message: (e && e.message) || 'Pravic ni bilo mogoče poslati.'})
      } finally {
        this.posiljanjeVProteku = false
        this.GetNaborPravicZaDodeljevanje(null, true)
      }
    },
    PrikaziRezultatDodelitve (odgovor) {
      let steviloUspesnih = (odgovor && typeof odgovor.grantedCount !== 'undefined') ? odgovor.grantedCount : 0
      let preskoceni = (odgovor && Array.isArray(odgovor.skipped)) ? odgovor.skipped : []
      if (steviloUspesnih > 0) {
        this.ShowSuccessMessage({
          message: steviloUspesnih > 1
            ? 'Uspešno poslanih pravic: ' + steviloUspesnih + '.'
            : 'Uspešno poslana pravica.'
        })
      }
      if (preskoceni.length > 0) {
        let seznam = preskoceni.map(p => p.scope + ' (' + p.reason + ')').join(', ')
        this.ShowWarningMessage({message: 'Preskočeno (' + preskoceni.length + '): ' + seznam})
      }
      if (steviloUspesnih === 0 && preskoceni.length === 0) {
        this.ShowWarningMessage({message: 'Ni bilo dodeljenih pravic.'})
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissions[]=PRIKLJUCKI']
        param.push('permissions[]=PREPAID_PRIKLJUCKI')
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.PRIKLJUCKI.additionalData,
        podatki.results.PREPAID_PRIKLJUCKI.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.seznamPrikljuckovGrupirano = groupedList
      let shranjenPrivzetPrikljucek =
        PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)
      if (list.find(x => x.id_prikljucek === shranjenPrivzetPrikljucek)) {
        this.izbranPrikljucek = shranjenPrivzetPrikljucek
      } else {
        list.filter(x => x.tip_prikljucka === 'FIX').forEach(prikljucek => {
          this.izbranPrikljucek = prikljucek.id_prikljucek
        })
      }
      if (this.izbranPrikljucek === '') {
        this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      }
      this.NaborPravicZaDodeljevanje()
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>

<style scoped>
.velikost-input {
  width: 330px;
}

.velikost-prikljucka{
  width: 330px;
}

/deep/ .el-form-item__label {
  font-weight: normal;
}

.odmik-gumba {
  padding-top: 50px;
}

/deep/ .el-table .cell {
  text-transform: none;
}

table, tr, td {
  padding: 25px 90px 0 0;
}

td:nth-child(4) {
  padding: 0;
}

.postavitev-vnosnih-podatkov {
  padding-top: 20px;
  padding-left: 40px;
}

#bottom {
  position: absolute;
  bottom: 0;
  right: 25px;
}

.zgornji-odmik-pomoc {
  margin-top: 90px;
  float: right;
}

.postavitev-besedila-pomoc {
  float: left;
  margin-right: 10px;
}

.fa {
  font-size: 48px;
  color: #f58220;
}

.desna-postavitev-ikone-pomoc {
  float: right;
}

.desni-pomik-texta-pomoc {
  float: right;
  text-align: right;
}

/* Preferirana širina 275px, a se nikoli ne razširi čez celico (na ožjih zaslonih se skrči). */
.velikost-selecta {
  width: 275px;
  max-width: 100%;
}

/* Gumb naj se ne prelamlja in ne odseka besedila. */
.tabela-pravice .el-button.gumb-potrdi {
  white-space: nowrap;
}

@media only screen and (max-width: 1600px) and (min-width: 1000px) {
  .stil-gumb-preklici {
    text-align: center;
  }
}

@media only screen and (max-width: 730px) {
  .povabilo-tekst{
    display: none !important;
  }

  .stil-gumb-preklici {
    display: block;
    text-align: center;
  }

  /deep/ .el-form-item__label {
    padding: 0 0 0 0;
    margin-bottom: -7px;
  }
  .tabela-pravice .el-button.gumb-potrdi {
    margin-left: 5px;
  }
}

@media only screen and (max-width: 600px) {
  .postavitev-vnosnih-podatkov {
    padding-left: 0;
  }

  .velikost-input, /deep/ .el-select {
    width: 100%;
  }

  .gumb-potrdi, /deep/ .el-input__inner {
    width: 100%;
  }
}

@media only screen and (max-width: 730px) {
  /deep/ .nova-vrstica-forma .el-form-item .el-form-item__content {
    display: block;
    width: 100%;
    margin-left: 0 !important;
  }
  .tabela-pravice .el-button.gumb-potrdi {
    font-size: 13px;
  }
  .stil-gumb-preklici {
    padding: 11px 11px 11px 11px !important;
    margin-left: 5px;
  }
}

@media only screen and (min-width: 1100px)  and (max-width: 1440px) {
  .velikost-selecta, .tabela-pravice .el-button.gumb-potrdi, .stil-gumb-preklici {
    min-width: 240px;
  }
}

@media only screen and (min-width: 1440px)  and (max-width: 1610px) {
  .stil-gumb-preklici {
    width: 160px;
    display: block;
  }
}

</style>

<!-- Nescoped blok z lastnim razredom (brez /deep/) za dostop do internih Element UI .el-tag.
     Dodatna .el-tag--info poveča specifičnost nad globalnim modrim !important stilom. -->
<style>
.oznake-scopov .el-tag,
.oznake-scopov .el-tag.el-tag--info {
  background-color: #fdf0e6 !important;
  border: 1px solid #f58220 !important;
  color: #8a4a00 !important;
}

.oznake-scopov .el-tag .el-tag__close,
.oznake-scopov .el-tag.el-tag--info .el-tag__close {
  color: #8a4a00 !important;
  background-color: transparent;
}

.oznake-scopov .el-tag .el-tag__close:hover,
.oznake-scopov .el-tag.el-tag--info .el-tag__close:hover {
  color: #fff !important;
  background-color: #8a4a00 !important;
}

/* --- Responsiven prikaz tabele pravic. V ne-scoped bloku s predpono .tabela-pravice
       (unikaten razred te tabele), da dosežemo interne Element elemente brez /deep/. --- */

/* Vsebina celic: ovije se med besedami; naziv (Tip) nikoli sredi besede. */
.tabela-pravice .cell {
  white-space: normal;
  overflow-wrap: break-word;
}
.tabela-pravice .tip-celica .cell {
  overflow-wrap: normal;
  word-break: normal;
}

/* Ovoj izbirnika brez horizontalnega odmika, da je izbirnik poravnan z gumbom. */
.tabela-pravice .e-naslov {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Poln tabelarični prikaz (mode '1', >= 1440px): celice poravnane na vrh (ob dolgem Opisu). */
@media only screen and (min-width: 1440px) {
  .tabela-pravice td {
    vertical-align: top;
  }
}

/* Vmesni prikaz (mode '0', 992-1439px): stolpca Tip | Izberi; v stolpcu Izberi sta izbirnik in
   gumb zložena in ENAKO široka (do 330px), info-ikona ob nazivu. Glave tabele ostanejo vidne.
   Prag 1440 je usklajen z JS mejnaSirinaTabela. */
@media only screen and (max-width: 1439px) {
  .tabela-pravice .izbira-celica .cell {
    max-width: 330px;
  }
  .tabela-pravice .izbira-celica .e-naslov {
    width: 100% !important;
  }
  .tabela-pravice .izbira-celica .mt-2 {
    width: 100%;
    margin-top: 12px;
  }
  .tabela-pravice .izbira-celica .el-select,
  .tabela-pravice .izbira-celica .el-select .el-input,
  .tabela-pravice .izbira-celica .el-select .el-input__inner {
    display: block;
    width: 100% !important;
    max-width: 100% !important;
  }
  .tabela-pravice .el-button.gumb-potrdi {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
  .tabela-pravice .stil-gumb-preklici {
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin-left: 0;
    text-align: center;
  }
  .tabela-pravice .info-ob-nazivu {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
  }
}

/* Telefon (< 992px): vsako pravico zložimo v navpično kartico — naziv (krepko) v svoji vrstici,
   pod njim izbirnik in gumb; glava tabele skrita, celice prozorne (bela kartica). */
@media only screen and (max-width: 991px) {
  .tabela-pravice .el-table__header-wrapper {
    display: none;
  }
  .tabela-pravice .el-table__body-wrapper table {
    width: 100% !important;
  }
  .tabela-pravice .el-table__body-wrapper colgroup {
    display: none;
  }
  .tabela-pravice .el-table__body-wrapper tbody,
  .tabela-pravice .el-table__body-wrapper tr,
  .tabela-pravice .el-table__body-wrapper td {
    display: block;
    width: 100% !important;
  }
  .tabela-pravice .el-table__body-wrapper tr {
    padding: 16px 0;
    border-bottom: 1px solid #ebeef5;
    background-color: transparent !important;
  }
  .tabela-pravice .el-table__body-wrapper td,
  .tabela-pravice .el-table__body-wrapper tr:hover > td {
    border: none;
    padding: 0;
    background-color: transparent !important;
  }
  .tabela-pravice .tip-celica {
    margin-bottom: 12px;
  }
  .tabela-pravice .tip-celica .cell {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 15px;
  }
}

/* Do 729px: izbirnik in gumb naj bosta čez POLNO širino (brez 330px omejitve). */
@media only screen and (max-width: 729px) {
  .tabela-pravice .izbira-celica .cell {
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/UporabnikiInPravice/Uporabniki.vue